<div class="dialog-container px-px-32 py-px-24">
  <div class="fw-7 fs-20">{{header}}</div>
  <div class="fw-3 fs-16">
    Vous pourrez sélectionner ce service d’affecation lors de la création de vos
    prochaines missions.
  </div>
  <app-custom-drop-down
    class="mt-px-16"
    label="Site"
    [required]="true"
    [multiple]="false"
    [apiFilter]="false"
    controlName="siteId"
    [options]="addressList"
    [loading]="loadingAddress"
    [parentForm]="form"
    [keyFilter]="'name'"
  ></app-custom-drop-down>

  <div [formGroup]="form" class="mt-px-16">
    <mat-label>Type du service <span class="required">*</span></mat-label>
    <input
      type="text"
      class="w-100"
      (input)="autoCompleteOnChange($event.target)"
      [matAutocomplete]="auto"
      formControlName="serviceType"
         autocomplete="off"
      [ngClass]="{
        'border-error':
          form.get('serviceType')?.touched && form.get('serviceType')?.invalid
      }"
    />
    <div
      *ngIf="
        form.get('serviceType')?.touched && form.get('serviceType')?.invalid
      "
      class="required fs-13"
    >
      Le type de service est requis !
    </div>
    <mat-autocomplete #auto="matAutocomplete"    autocomplete="off">
      @if (loadingAff) {
      <mat-option [value]="">Loading...</mat-option>
      } @else { @for (option of affectationFilterList; track option) {
      <mat-option [value]="option.label">{{ option.label }}</mat-option>
      } @empty {
      <div>Pas de service à ce nom</div>
      } }
    </mat-autocomplete>
  </div>
  <div class="row">
    <div class="col-6">
      <app-custom-input
        label="Nom du service"
        innerClass="mt-px-16"
        [parentForm]="form"
        controlName="name"
      ></app-custom-input>
    </div>
    <div class="col-6">
      <app-custom-input
        label="Nombre de lits ou de salles"
        type="number"
        innerClass="mt-px-16"
        [parentForm]="form"
        controlName="numberOfBedsOrRooms"
      ></app-custom-input>
    </div>
  </div>

  <div class="row">
    <div class="col-6">
      <app-custom-input
        label="Nombre de patients prise en charge par an"
        type="number"
        innerClass="mt-px-16"
        [parentForm]="form"
        controlName="numberOfPatientsCaredForPerYear"
      ></app-custom-input>
    </div>
    <div class="col-6">
      <app-custom-input
        label="Effectif du personnel"
        type="number"
        innerClass="mt-px-16"
        [parentForm]="form"
        controlName="numberOfStaffWorkingInService"
      ></app-custom-input>
    </div>
  </div>

  <div class="row">
      <app-custom-input
        label="Email du responsable"
        innerClass="mt-px-16"
        [parentForm]="form"
        controlName="email"
      ></app-custom-input>
  </div>
  <app-text-separator
    text="Description"
    innerClass="mt-px-16"
  ></app-text-separator>
  <app-custom-input
    label="Description"
    placeholder="Ecrire ici une description de votre service (activités, spécificités …)"
    innerClass="my-px-16"
    [required]="false"
    [max]="500"
    [parentForm]="form"
    [errorMessage]="'Vous avez dépassé la limite de 500 caractères'"
    controlName="serviceDescription"
    type="textarea"
  ></app-custom-input>
  <app-text-separator
    text="Photos du service"
    innerClass="mt-px-16"
  ></app-text-separator>

  <app-custom-dragdrop-image
    (sendImage)="getImage($event)"
    [url]="affectationImages"
    [isDeletble]="true"
    [limit]="3"
  ></app-custom-dragdrop-image>
  <div class="fs-11 text-secondary">
    Ajouter des photos augmente vos chances de trouver un candidat à vos futures
    missions.
  </div>
  <app-text-separator
    text="FICHES DE POSTE"
    innerClass="mt-px-16"
  ></app-text-separator>
  <app-upload-file
    class="mt-px-16"
    label="Ajoutez les fiches de poste de votre service au format PDF"
    [multiple]="true"
    (sendFileWithId)="getFile($event, 'fichePostes')"
    (deleteFile)="deleteFile($event, 'fichePostes')"
    [files]="fichePosteFiles"
    [required]="true"
  ></app-upload-file>
  <div class="fs-11 text-secondary">
    Nommer clairement vos fichiers afin de les retrouver facilement lors de la
    création d’une nouvelle mission
  </div>
</div>

<mat-dialog-actions align="end" class="mt-px-24">
  <app-button
    [text]="'Annuler'"
    [stroked]="true"
    (handleClick)="close(false)"
  ></app-button>
  <app-button
    [text]="data.isModify ? 'Modifier' : 'Ajouter'"
    [loading]="loading"
    [disabled]="form.invalid"
    (handleClick)="addAffectationServices()"
    innerClass="ml-px-8"
  ></app-button>
</mat-dialog-actions>
<!--dialog-container-->
